// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__qs3oe","containerPhone":"styles_containerPhone__eqqAS","phone":"styles_phone__96cH7","text":"styles_text__VNX5U","button":"styles_button__h15Ux"};